import React, { useMemo } from "react";
import TextareaAutosize from "react-textarea-autosize";
import "./InputField.module.css";
import { DEFAULT_TEXT, getUserConfigText } from "../../config";
import { useConfig } from "../Widget/ConfigContext";
import { calcContrastColor } from "../Widget/BubbleWidget";

/**
 * @typedef {import('../../types/config').ConfigObject} ConfigObject
 */
/**
 * @param {{
 * inboundMessage: any,
 * setInboundMessage: any,
 * onKeyEnter: any,
 * placeholder: string,
 * isLoading: boolean
 *}} param0
 */
export function InputField({
  inboundMessage,
  setInboundMessage,
  onKeyEnter,
  isLoading,
}) {
  const { config, colors } = useConfig();

  const whiteLabel = useMemo(() => {
    const entitlements = config.entitlements;
    return !!entitlements && entitlements.includes("white_label");
  }, [config]);

  const placeholderText = useMemo(
    () => getUserConfigText(config, "placeholder", "Ask us anything!"),
    [document.cookie, config.overrideLanguage],
  );

  const footerDisclaimerText = useMemo(
    () =>
      getUserConfigText(
        config,
        "footerDisclaimer",
        DEFAULT_TEXT.en.footerDisclaimer,
      ),
    [document.cookie, config.overrideLanguage],
  );

  return (
    <div
      style={{
        margin: "0",
      }}
    >
      <div
        style={{
          alignItems: "center",
          borderRadius: config.widgetType === "inline" ? "0" : "0 0 1rem 1rem ",
        }}
      >
        <div
          style={{
            padding: "1rem max(1.25rem, 20px)",
            display: "flex",
            alignItems: "flex-end",
            width: "100%",
          }}
        >
          {config.allowInputWrap ? (
            <TextareaAutosize
              dir="auto"
              value={inboundMessage}
              placeholder={placeholderText}
              rows={1}
              maxRows={10}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  onKeyEnter();
                  setInboundMessage("");
                }
              }}
              onChange={(e) => {
                setInboundMessage(e.target.value);
              }}
              style={{
                overflow: "hidden",
                fontFamily: "sans-serif",
                fontSize: config.inputFontSize,
                border: "0 solid black",
                outline: "none",
                flexGrow: 1,
                overflowY: "scroll",
                color: "black ",
                resize: "none",
                padding: "0",
                marginBottom: "4px",
              }}
            />
          ) : (
            <input
              dir="auto"
              value={inboundMessage}
              placeholder={placeholderText}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onKeyEnter();
                }
              }}
              onChange={(e) => setInboundMessage(e.target.value)}
              style={{
                fontSize: config.inputFontSize,
                border: "0 solid black",
                outline: "none",
                boxSizing: "border-box",
                flexGrow: 1,
                color: "black ",
                padding: "0",
                marginBottom: "4px",
              }}
            />
          )}

          <button
            id="send-button"
            onClick={onKeyEnter}
            aria-label="send message"
          >
            <img
              src={
                "https://storage.googleapis.com/customer-icons/ar2sa5pyojw0-paper-plane-airplane-4-digits-computer-icons-airplane-544eba82b4a4d7b489d5d5fcc83b05ef.png"
              }
              alt="paper airplane icon"
              style={
                {
                  // we don't currently support recoloring the main panel
                  // background, but once we do this will be necessary to
                  // properly color the send button
                  //
                  // filter:
                  //   calcContrastColor(colors.main) === "white"
                  //     ? "invert(100%)"
                  //     : "",
                }
              }
            />
          </button>
        </div>
      </div>
      {footerDisclaimerText && (
        <div
          dir="auto"
          style={{
            paddingBottom: "0.75rem",
            paddingLeft: "0.75rem",
            paddingRight: "0.75rem",
            fontFamily: "sans-serif",
            fontSize: config.footerDiscFontSize,
            fontWeight: config.footerDiscFontWeight,
            lineHeight: "1em",
            color: "gray",
            textAlign: "center",
          }}
        >
          {footerDisclaimerText}
        </div>
      )}
      {whiteLabel ? (
        <></>
      ) : (
        // <a
        //   id="magicform-label"
        //   href="https://magicform.ai/"
        //   target="_blank"
        //   style={{
        //     textDecoration: "none",
        //     color: "black",
        //   }}
        // >
        //   <p>Powered by MagicForm ✨</p>
        // </a>
        <></>
      )}
    </div>
  );
}
